<button type="button" class="btn btn-primary" (click)="newWebProject()">
  <fa-icon [icon]="faPlusCircle" class="fa-lg"></fa-icon> Web Project
</button>
